import React from "react";
import { object, array, bool, string, number } from "prop-types";
import { connect } from "react-redux";
import get from "lodash/get";

import More from "../../../atoms/More";
import NewsWithImage from "../../../molecules/NewsWithImage";
import CollectionTitleWithArrow from "../../../atoms/CollectionTitleWithArrow";
import NewsHeadline from "../../../atoms/NewsHeadline";

import { staticTexts } from "../../../utils/Translate";
import { getSlug, getCollectionName } from "../../../utils/utils";

import "./organism1.m.css";

const Organism1 = ({
  collection,
  sections,
  showCollectionName,
  showLoadMoreButton,
  lang,
  domainSlug,
  storiesToLoad,
}) => {
  const stories =
    collection && collection.items
      ? collection.items.filter((item) => item.type === "story").slice(0, storiesToLoad)
      : null;
  const navigateTo = get(collection, ["associated-metadata", "navigate_to"], "");
  const navigateToTitle = get(collection, ["associated-metadata", "navigate_to_title"], "");
  const collectionSlug = navigateTo ? `/${navigateTo}` : getSlug(collection, sections, domainSlug);
  const collectionName = getCollectionName(collection, navigateToTitle);

  const renderListStories =
    stories.length > 1 &&
    stories.slice(1, 3).map((item, index) => (
      <div
        styleName={`${stories.length > 3 ? "list-story " : "list-story custom-border"} ${
          index === 1 ? "no-border" : ""
        }`}
        key={index}
      >
        <NewsHeadline key={index} story={item.story} cssStyleName="mediumSize" />
      </div>
    ));

  return stories && stories.length > 0 ? (
    <div styleName="collection-wrapper" className="collection-wrapper">
      <div>
        {showCollectionName && (
          <CollectionTitleWithArrow collectionName={collectionName} collectionSlug={collectionSlug} />
        )}
        {stories[0] && (
          <div>
            <NewsWithImage story={stories[0].story} cssStyleName="mediumSize" />
          </div>
        )}
      </div>
      {renderListStories}
      {!showLoadMoreButton && stories.length > 3 && (
        <div styleName={`read-more-button`}>
          <More type="read-more" collection={collection} text={staticTexts(lang).loadMore} />
        </div>
      )}
    </div>
  ) : null;
};

const mapStateToProps = (state) => ({
  sections: get(state, ["qt", "config", "sections"], []),
  lang: get(state, ["qt", "config", "publisher-attributes", "lang"], ""),
  domainSlug: get(state, ["qt", "config", "domainSlug"], ""),
});

Organism1.propTypes = {
  collection: object,
  sections: array,
  showCollectionName: bool,
  showLoadMoreButton: bool,
  lang: string,
  domainSlug: string,
  storiesToLoad: number,
};

export default connect(mapStateToProps)(Organism1);
